import RouterComponent from "./Router";

export default RouterComponent;
